import { serializeWalletFilters } from '@modules/consolidator/utils/serialize-wallet-filters/serialize-wallet-filters'

/**
 * Serializa os params da consolidação por CLIENTE.
 *
 * A guarda abaixo é proteção real do caminho por cliente: sem
 * `id_cliente_app` (e fora do fluxo do próprio cliente logado) a requisição
 * não pode sair. O caminho por grupo familiar tem serializer próprio
 * (`serialize-group-wallet-params`) justamente para não afrouxá-la.
 */
export const serializeWalletAnalysisParams = ({
  id_cliente_app,
  is_client,
  ...filters
} = {}) => {
  if (!is_client && !id_cliente_app) {
    return { error: 'Não foi possível identificar o cliente.' }
  }

  return { params: serializeWalletFilters(filters) }
}
